// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3AEpI","select":"Header_select__1N9Yp","clinic":"Header_clinic__2lFGz"};